export default () => {
  jQuery(($) => {
    $('[aria-expanded]').each(function() {
      let status = $(this).attr('aria-expanded') === 'true'
      $(this).click(function() {
        status = !status
        $(this).attr('aria-expanded', status)
      })
    })
  })
}
